import React from "react";

import styles from './checkBoxInput.module.css'

function CheckBoxInput(props) {

    return (
        <label className={`${props.bold ? `${styles.bold} ${props.checked !== "0" ? styles.checked : ''}` : ''}`}>
            <div className={`${styles.inputCheckBox} ${styles.bounce}`}>
                <input
                    type={"checkbox"}
                    checked={props.checked !== "0"}
                    onChange={() => props.id ? props.setChecked(props.id) : props.setChecked(props.checked === '0' ? '1' : '0')}
                />
                <svg viewBox="2.5 2.5 16 16">
                    <polyline points="5 10.75 8.5 14.25 16 6"></polyline>
                </svg>
            </div>
            <span className={styles.text}>{props.text}</span>
        </label>
    )
}

export default CheckBoxInput